// src/api/billing.js
import { http } from "./http";

export async function getMe(userId) {
  const { data } = await http.get("/me", { params: { user_id: userId } });
  return data; // { user_id, plan, plan_status, current_period_end, billing_provider }
}
export async function getPlans() {
  const { data } = await http.get("/billing/plans");
  return data.plans;
}
export async function startCheckout(userId, plan) {
  const { data } = await http.post("/billing/checkout", { user_id: userId, plan });
  return data.checkout_url;
}
export async function openPortal(userId) {
  const { data } = await http.get("/billing/portal", { params: { user_id: userId } });
  return data.portal_url;
}
